import clsx from 'clsx';

const Parentheses = ({ index = 1, isActive = false }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 93.55 93.55"
      className={clsx('parentheses', `parentheses_${index}`, { active: isActive })}
    >
      <path d="M93.55,66.4h-14.6V12.28h-32.36V0h46.96v66.4Z" fill="#3e29ff" />
      <path d="M0,27.15h14.6v54.12h32.36v12.28H0V27.15Z" fill="#3e29ff" />
    </svg>
  );
};

export default Parentheses;
